import script from "./GruposAcessoCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./GruposAcessoCadastro.vue?vue&type=script&setup=true&lang=js"

import "./GruposAcessoCadastro.vue?vue&type=style&index=0&id=ffd0cc78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd0cc78"]])

export default __exports__